import { dispatchAction } from '@ardoq/rxbeach';
import {
  setStartTypeAndTraversalStartSetOrCount,
  setTraversals,
} from './traversals/editTraversalActions';
import {
  resetAllSearchState,
  resetSharedSearchState as resetSharedSearchStateAction,
} from '../search/actions';
import { resetSelectedView } from './selectedView/actions';
import { resetViewpointBuilderNavigation } from './viewpointBuilderNavigation/actions';
import { resetTraversalBuilderState } from './traversals/editTraversalActions';
import { resetFormattingState } from './formattingTabs/viewpointBuilderFormattingActions';

const resetComponentSearchState = (namespace: string) => {
  dispatchAction(resetAllSearchState(), namespace);
};

export const resetSharedSearchState = () => {
  dispatchAction(resetSharedSearchStateAction());
};

const resetEditTraversalState = (namespace: string) => {
  dispatchAction(resetTraversalBuilderState(), namespace);
  dispatchAction(
    setStartTypeAndTraversalStartSetOrCount({
      startType: null,
      traversalStartSet: [],
    }),
    namespace
  );
  dispatchAction(setTraversals({ paths: [], filters: null }), namespace);
};

export const resetViewpointBuilder = (namespace: string) => {
  resetComponentSearchState(namespace);
  resetSharedSearchState();
  resetEditTraversalState(namespace);
  dispatchAction(resetSelectedView(), namespace);
  dispatchAction(resetViewpointBuilderNavigation(), namespace);
  dispatchAction(resetFormattingState(), namespace);
};
